import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import {
  EventReqDtos,
  HospitalCenterReqDto,
  LeadRespDto,
  LeadsDto,
} from '../../../api/interfaces/LeadsDto';
import {
  getBookStatus,
  getDotColor,
  getEventTypes,
  getStatusClass,
  getStatusDisplayName,
} from '../../../utility/RolesUtility';
import { getService } from '../../../servce/ApisService';
import { API_ENDPOINTS } from '../../../api';
import { useLoader } from '../../../Loader/LoaderContext';

// Define the type for the section names
type SectionName =
  | 'bannerAds'
  | 'emailMarketing'
  | 'contentMarketing'
  | 'printAdvertisement'
  | 'additionalService'
  | 'eNewsLetter'
  | 'isEventListing';
const ServiceDetails = () => {
  const location = useLocation();
  const path = location.pathname;
  const navigate = useNavigate();
  const [data, setData] = useState<LeadsDto>();
  const [searchParams] = useSearchParams();
  const userId = searchParams.get('bookingid');
  const { setLoading } = useLoader();
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
  const [submittedData, setSubmittedData] = useState<LeadsDto | null>(null);
  // State to track the open/closed status of each section with explicit typing
  const [openSections, setOpenSections] = useState<{
    [key in SectionName]: boolean;
  }>({
    bannerAds: false,
    emailMarketing: false,
    contentMarketing: false,
    printAdvertisement: false,
    additionalService: false,
    eNewsLetter: false,
    isEventListing: false,
  });

  useEffect(() => {
    fetchVehicles();
  }, []);

  const fetchVehicles = async () => {
    setLoading(true);
    try {
      let url: any;
      // if(path === '/portals/leads/ViewDetails'){

      if (userInfo.roles === 'SALES_MANAGER') {
        url = API_ENDPOINTS.editSalesManagerProposalBooking;
      } else if (userInfo.roles === 'SALES_ADMIN') {
        url = API_ENDPOINTS.editSalesAdminProposalBooking;
      } else if (userInfo.roles === 'SALES_TEAM_LEAD') {
        url = API_ENDPOINTS.editSalesTlProposalBooking;
      } else if (userInfo.roles === 'SALES_EXECUTIVE') {
        url = API_ENDPOINTS.editSalesExecutiveProposalBooking;
      }
      const response = await getService(url + '?bookingId=' + userId);
      console.log(response);
      setData(response.data);
    } catch (error) {
      console.error('Error fetching vehicle data:', error);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  };

  console.log('data', data);

  const users = () => {
    if (path === 'portals/vendors/activeVendor/serviceDetails') {
      navigate('/portals/vendors/activeVendor');
    } else if (path === '/portals/proposals/viewProposal/serviceDetails') {
      navigate('/portals/proposals/viewProposal');
    } else if (path === 'portals/vendors/inActiveVendor/serviceDetails') {
      navigate('/portals/vendors/inActiveVendor');
    } else if (path === 'portals/bookings/confirmedBooking/serviceDetails') {
      navigate('/portals/bookings/confirmedBooking');
    } else if (path === 'portals/bookings/viewBooking/serviceDetails') {
      navigate('/portals/bookings/viewBooking');
    }
  };

  const getleadType: Record<string, string> = {
    COMPANY: 'Company Name',
    EVENT_ORGANIZER: 'Event Organiser Name',
    HOSPITAL: 'Hospital Name',
  };
  const leadTypeMapping: Record<string, string> = {
    COMPANY: 'Company',
    EVENT_ORGANIZER: 'Event Organiser',
    HOSPITAL: 'Hospital',
  };
  const leadTypeMappings: Record<string, string> = {
    COMPANY: 'Company Details',
    EVENT_ORGANIZER: 'Event Organiser Details',
    HOSPITAL: 'Hospital Details',
  };
  const getCenterSize: Record<string, string> = {
    SMALL: 'Small',
    MEDIUM: 'Medium',
    LARGE: 'Large',
  };

  const editProfile = (data: any) => {
    if (data?.id) {
      navigate('/portals/bookings/addBooking?bookingId=' + data?.id);
    } else {
      console.warn('Data ID is undefined');
    }
  };

  const editProposal = (data: any) => {
    if (data?.id) {
      navigate(
        `/portals/proposals/convertToProposal?appUserId=${
          data?.leadId
        }&companyName=${encodeURIComponent(data?.companyName)}`
      );
      // navigate("/portals/proposals/addProposal?appUserId=" + data?.leadId);
    } else {
      console.warn('Data ID is undefined');
    }
  };

  // Function to toggle a specific section with explicit sectionName type
  const toggleSection = (sectionName: SectionName) => {
    setOpenSections((prevState) => ({
      ...prevState,
      [sectionName]: !prevState[sectionName], // Toggle the specific section
    }));
  };

  const handleNavigation = () => {
    navigate(-1);
    // navigate("/portals/bookings/viewBooking"); // Navigate to the desired route
  };
  
  return (
    <div className='h-full py-2 w-full'>
      <div className='flex items-center cursor-pointer mb-4'>
        <h2
          className='mr-2 text-gray-700 font-semibold text-sm'
          onClick={users}
        >
          {path === '/portals/proposals/viewProposal/serviceDetails'
            ? 'Proposal'
            : path === '/portals/bookings/confirmedBooking/serviceDetails'
            ? 'View Confirmed'
            : path === '/portals/bookings/viewBooking/serviceDetails'
            ? 'View Booked'
            : 'Vendors'}
        </h2>
        <img src='/images/arrowIcons.svg' className='mr-2' />
        <span className='text-gray-400 font-semibold text-sm'>
          {path === '/portals/bookings/confirmedBooking/serviceDetails' ||
          path === '/portals/bookings/viewBooking/serviceDetails'
            ? data?.uuid
            : data?.companyName
            ? data?.companyName
            : 'NA'}
        </span>
      </div>
      <div
        className='flex gap-2 items-center font-sans pb-7 cursor-pointer'
        onClick={handleNavigation}
      >
        <img src='/images/Back or Arrow left (1).svg' />
        <p className='text-[#2D2E2F] font-bold text-2xl'>
          {path === '/portals/bookings/confirmedBooking/serviceDetails' ||
          path === '/portals/bookings/viewBooking/serviceDetails'
            ? data?.uuid
            : data?.companyName
            ? data?.companyName
            : 'NA'}
        </p>
      </div>
      <div className='bg-white w-auto h-auto p-6'>
        {/* <p className="border"></p> */}
        <div className='font-Inter'>
          <div className='justify-between flex pt-2 pb-4'>
            <p className='font-semibold text-xl'>Service Details</p>
          </div>
          <div>
            {data?.proposalType !== 'COMPANY' &&
              (data?.isEventProfiling || data?.isHospitalProfiling) && (
                <div className='bg-[#FFF2F5] rounded-md mb-5'>
                  <p className='text-base font-semibold px-4 py-3'>
                    {data?.proposalType === 'EVENT_ORGANIZER'
                      ? 'Event Organiser Profiling'
                      : 'Hospital Profiling'}
                  </p>
                </div>
              )}
            {/* {( data?.isEventListing) && ( */}
            <div className='mb-5'>
              {data?.isEventListing && (
                <div
                  className='bg-[#FFF2F5] flex items-center justify-between cursor-pointer'
                  onClick={() => toggleSection('isEventListing')}
                >
                  <p className='text-base font-semibold px-4 py-3'>
                    Event Organiser Listing
                  </p>
                  <span>
                    <img
                      className={`size-6 w-14 h-8 ${
                        openSections.isEventListing
                          ? 'rotate-[180deg]'
                          : 'rotate-[0deg]'
                      }`}
                      src='/images/rightIcon.svg'
                    />
                  </span>
                </div>
              )}
              {openSections.isEventListing && (
                <>
                  <p className='border'></p>
                  <div className='bg-[#F6F6F6] p-4 mb-5'>
                    <div className='flex gap-10 mb-5'>
                      <div>
                        <p className='text-[#6D6D6D] font-semibold text-sm'>
                          Start date
                        </p>
                        <p className='text-[#374151] font-semibold text-sm'>
                          {data?.eventListingFrom
                            ? data?.eventListingFrom
                            : 'NA'}
                        </p>
                      </div>
                      <p className='border'></p>
                      <div>
                        <p className='text-[#6D6D6D] font-semibold text-sm'>
                          End date
                        </p>
                        <p className='text-[#374151] font-semibold text-sm'>
                          {data?.eventListingTo ? data?.eventListingTo : 'NA'}
                        </p>
                      </div>
                    </div>
                    <div>
                      <p className='text-[#6D6D6D] font-semibold text-sm'>
                        Number of Events
                      </p>
                      <p className='text-[#374151] text-base font-semibold '>
                        {data?.noOfEvents ? data?.noOfEvents : 'NA'}
                      </p>
                    </div>
                  </div>
                </>
              )}
            </div>

            {(data?.proposalType === 'PROPOSAL' || data?.proposalType === 'BOOKED')  && data?.isCompanyProfiling && (
              <div className='bg-[#FFF2F5] rounded-md mb-5'>
                <p className='text-base font-semibold px-4 py-3'>
                  Company Profiling
                </p>
              </div>
            )}
            <div className='mb-5'>
              {data?.isContentMarketing && (
                <div
                  className='bg-[#FFF2F5] flex items-center justify-between cursor-pointer'
                  onClick={() => toggleSection('contentMarketing')}
                >
                  <p className='text-base font-semibold px-4 py-3'>
                    Content Marketing
                  </p>
                  <span>
                    <img
                      className={`size-6 w-14 h-8 ${
                        openSections.contentMarketing
                          ? 'rotate-[180deg]'
                          : 'rotate-[0deg]'
                      }`}
                      src='/images/rightIcon.svg'
                    />
                  </span>
                </div>
              )}
              {openSections.contentMarketing && (
                <>
                  <p className='border'></p>
                  <div className='bg-[#F6F6F6] p-4 mb-5'>
                    <div className='mb-5'>
                      <p className='text-[#6D6D6D] font-semibold text-sm'>
                        Number of Posts
                      </p>
                      <p className='text-[#374151] text-base font-semibold '>
                        {data?.noOfPosts ? data?.noOfPosts : 'NA'}
                      </p>
                    </div>
                    <div className='flex gap-10 mb-10'>
                      <div>
                        <p className='text-[#6D6D6D] font-semibold text-sm'>
                          Start date
                        </p>
                        <p className='text-[#374151] font-semibold text-sm'>
                          {data?.contntMarktAdFrom
                            ? data?.contntMarktAdFrom
                            : 'NA'}
                        </p>
                      </div>
                      <p className='border'></p>
                      <div>
                        <p className='text-[#6D6D6D] font-semibold text-sm'>
                          End date
                        </p>
                        <p className='text-[#374151] font-semibold text-sm'>
                          {data?.contntMarktAdTo ? data?.contntMarktAdTo : 'NA'}
                        </p>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
            <div className='mb-5'>
              {data?.isBannerAds && (
                <div
                  className='bg-[#FFF2F5] flex items-center justify-between cursor-pointer'
                  onClick={() => toggleSection('bannerAds')}
                >
                  <p className='text-base font-semibold px-4 py-3'>
                    Banner ads
                  </p>
                  <span>
                    <img
                      className={`size-6 w-14 h-8 ${
                        openSections.bannerAds
                          ? 'rotate-[180deg]'
                          : 'rotate-[0deg]'
                      }`}
                      src='/images/rightIcon.svg'
                    />
                  </span>
                </div>
              )}
              {openSections.bannerAds && (
                <>
                  <p className='border'></p>
                  <div className='bg-[#F6F6F6] p-4 mb-5'>
                    <div className='flex gap-10 mb-5'>
                      <div>
                        <p className='text-[#6D6D6D] font-semibold text-sm'>
                          Start date
                        </p>
                        <p className='text-[#374151] font-semibold text-sm'>
                          {data?.bannerAdFrom ? data?.bannerAdFrom : 'NA'}
                        </p>
                      </div>
                      <p className='border'></p>
                      <div>
                        <p className='text-[#6D6D6D] font-semibold text-sm'>
                          End date
                        </p>
                        <p className='text-[#374151] font-semibold text-sm'>
                          {data?.bannerAdTo ? data?.bannerAdTo : 'NA'}
                        </p>
                      </div>
                    </div>
                    <div>
                      <p className='text-[#6D6D6D] font-semibold text-sm'>
                        Number of Banners
                      </p>
                      <p className='text-[#374151] text-base font-semibold '>
                        {data?.noOfBanners ? data?.noOfBanners : 'NA'}
                      </p>
                    </div>
                  </div>
                </>
              )}
            </div>

            <div className='mb-5'>
              {data?.isEmailMarketing && (
                <div
                  className='bg-[#FFF2F5] flex items-center justify-between cursor-pointer'
                  onClick={() => toggleSection('emailMarketing')}
                >
                  <p className='text-base font-semibold px-4 py-3'>
                    Email Marketing
                  </p>
                  <span>
                    <img
                      className={`size-6 w-14 h-8 ${
                        openSections.emailMarketing
                          ? 'rotate-[180deg]'
                          : 'rotate-[0deg]'
                      }`}
                      src='/images/rightIcon.svg'
                    />
                  </span>
                </div>
              )}
              {openSections.emailMarketing && (
                <>
                  <p className='border'></p>
                  <div className='bg-[#F6F6F6] p-4 mb-5'>
                    <div className='mb-5'>
                      <p className='text-[#6D6D6D] font-semibold text-sm'>
                        Number of Counts
                      </p>
                      <p className='text-[#374151] text-base font-semibold '>
                        {data?.noOfRecipients ? data?.noOfRecipients : 'NA'}
                      </p>
                    </div>
                    <div>
                      <p className='text-[#6D6D6D] font-semibold text-sm'>
                        Number of EDMs
                      </p>
                      <p className='text-[#374151] text-base font-semibold '>
                        {data?.noOfEdms ? data?.noOfEdms : 'NA'}
                      </p>
                    </div>
                  </div>
                </>
              )}
            </div>
            <div className='mb-5'>
              {data?.isNewsLetterAds && (
                <div
                  className='bg-[#FFF2F5] flex items-center justify-between cursor-pointer'
                  onClick={() => toggleSection('eNewsLetter')}
                >
                  <p className='text-base font-semibold px-4 py-3'>
                    Ads in e-newsletter
                  </p>
                  <span>
                    <img
                      className={`size-6 w-14 h-8 ${
                        openSections.eNewsLetter
                          ? 'rotate-[180deg]'
                          : 'rotate-[0deg]'
                      }`}
                      src='/images/rightIcon.svg'
                    />
                  </span>
                </div>
              )}
              {openSections.eNewsLetter && (
                <div className='bg-[#F6F6F6] p-4 mb-5'>
                  <div className='flex gap-10 mb-5'>
                    <div>
                      <p className='text-[#6D6D6D] font-semibold text-sm'>
                        Start date
                      </p>
                      <p className='text-[#374151] font-semibold text-sm'>
                        {data?.newsLetterAdFrom ? data?.newsLetterAdFrom : 'NA'}
                      </p>
                    </div>
                    <p className='border'></p>
                    <div>
                      <p className='text-[#6D6D6D] font-semibold text-sm'>
                        End date
                      </p>
                      <p className='text-[#374151] font-semibold text-sm'>
                        {data?.newsLetterAdTo ? data?.newsLetterAdTo : 'NA'}
                      </p>
                    </div>
                  </div>
                  <div>
                    <p className='text-[#6D6D6D] font-semibold text-sm'>
                      Number of e-newsletter
                    </p>
                    <p className='text-[#374151] text-base font-semibold '>
                      {data?.noOfNewsBanners ? data?.noOfNewsBanners : 'NA'}
                    </p>
                  </div>
                </div>
              )}
            </div>

            <div className='mb-5'>
              {data?.isPrintAd && (
                <div
                  className='bg-[#FFF2F5] flex items-center justify-between cursor-pointer'
                  onClick={() => toggleSection('printAdvertisement')}
                >
                  <p className='text-base font-semibold px-4 py-3'>
                    Print Advertisement
                  </p>
                  <span>
                    <img
                      className={`size-6 w-14 h-8 ${
                        openSections.printAdvertisement
                          ? 'rotate-[180deg]'
                          : 'rotate-[0deg]'
                      }`}
                      src='/images/rightIcon.svg'
                    />
                  </span>
                </div>
              )}
              {openSections.printAdvertisement && (
                <>
                  <p className='border'></p>
                  <div className='bg-[#F6F6F6] p-4 mb-5'>
                    <div className='mb-5'>
                      <p className='text-[#6D6D6D] font-semibold text-sm'>
                        Number of Advertisements
                      </p>
                      <p className='text-[#374151] text-base font-semibold '>
                        {data?.printAdd ? data?.printAdd : 'NA'}
                      </p>
                    </div>
                    <div className='mb-5'>
                      <p className='text-[#6D6D6D] font-semibold text-sm'>
                        Number of Issues
                      </p>
                      <p className='text-[#374151] text-base font-semibold '>
                        {data?.noOfPrintAds ? data?.noOfPrintAds : 'NA'}
                      </p>
                    </div>
                  </div>
                </>
              )}
            </div>
            {data?.proposalType !== 'EVENT_ORGANIZER' && (
              <>
                {data?.additionalService && (
                  <div
                    className='bg-[#FFF2F5] flex items-center justify-between cursor-pointer'
                    onClick={() => toggleSection('additionalService')}
                  >
                    <p className='text-base font-semibold px-4 py-3'>
                      Additional Services
                    </p>
                    <span>
                      <img
                        className={`size-6 w-14 h-8 ${
                          openSections.additionalService
                            ? 'rotate-[180deg]'
                            : 'rotate-[0deg]'
                        }`}
                        src='/images/rightIcon.svg'
                      />
                    </span>
                  </div>
                )}
                {openSections.additionalService && (
                  <>
                    <p className='border'></p>
                    <div className='bg-[#F6F6F6] p-4 mb-5'>
                      <div className='mb-5'>
                        <p className='text-[#6D6D6D] font-semibold text-sm'>
                          Additional Services
                        </p>
                        <p className='text-[#374151] text-base font-semibold '>
                          {data?.additionalService
                            ? data?.additionalService
                            : 'NA'}
                        </p>
                      </div>
                    </div>
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceDetails;
